export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -8 });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const scrollToTop = (immediate = true) => {
  if (window.__lenis) window.__lenis.scrollTo(0, { immediate });
  else window.scrollTo(0, 0);
};
